<template>
  <div class="user" v-show="exitshow" :style="'min-height:' + minHeight">
    <div class="hit" v-if="hit">
      {{ hit }}
    </div>
    <div class="user_exit">
      <div
        class="user_face"
        :style="
          tab == 3
            ? 'min-height: 12880px;'
            : tab == 5
            ? 'min-height: 783px;'
            : 'min-height: 739px;'
        "
      >
        <div class="imgPreview">
          <img :src="usermsg.face" id="img3" />
          <div class="anchor_tab" v-if="verify == 1">
            <img src="//static.jiil1.com/static/image/anchor_tab.png" />
          </div>
          <div class="anchoricon" v-if="verify == 1">
            <img src="//static.jiil1.com/static/image/anchoricon.png" />
          </div>
        </div>
        <div class="user_name">
          {{ usermsg.user_name }}
        </div>
        <div
          :class="tab == 1 ? 'user_tab active' : 'user_tab'"
          @click="tab = 1"
        >
          <i class="iconfont2">&#xe636;</i>
          <span>个人资料</span>
        </div>
        <div
          :class="tab == 5 ? 'user_tab active' : 'user_tab'"
          @click="tab = 5"
        >
          <i class="iconfont2">&#xe649;</i>
          <span>我的关注</span>
        </div>
        <div
          :class="tab == 2 ? 'user_tab active' : 'user_tab'"
          @click="tab = 2"
        >
          <i class="iconfont2">&#xe635;</i>
          <span>申请开播</span>
        </div>
        <div
          :class="tab == 3 ? 'user_tab active' : 'user_tab'"
          @click="tab = 3"
          v-if="userType > 1"
        >
          <i class="iconfont2">&#xe638;</i>
          <span>开播教程</span>
        </div>
        <div
          :class="tab == 4 ? 'user_tab active' : 'user_tab'"
          @click="tab = 4"
          v-if="userType == 2 || userType == 9"
        >
          <i class="iconfont2">&#xe63c;</i>
          <span>开始直播</span>
        </div>
      </div>
      <div class="usermsgOuter" :style="tab == 5 ? 'min-height: 783px;' : ''">
        <div class="bind_alert_outer" v-if="follow_Unbound_alert">
          <div class="bind_alert">
            <div class="bind_alert_title">
              取消关注后您将不能及时接收主播开播通知，是否要取消关注？
            </div>
            <div class="bind_alert_btn">
              <div
                class="bind_confirm"
                @click="follow_Unbound(currfollow, currindex)"
              >
                确定
              </div>
              <div class="bind_cancel" @click="follow_Unbound_alert = 0">
                取消
              </div>
            </div>
          </div>
        </div>
        <div class="closeExit" @click="callParentClose()">关闭</div>
        <div class="tab" v-show="tab == 1">
          <span :class="tab_data != 2 ? 'active' : ''" @click="tab_data = 1"
            >基本信息</span
          ><span :class="tab_data == 2 ? 'active' : ''" @click="tab_data = 2"
            >微信管理</span
          >
          <div
            :class="'line tabData' + tab_data"
            :style="'left:' + ((tab_data - 1) * 100 + 49) + 'px'"
          ></div>
        </div>
        <div class="user_msg" v-show="tab == 1 && tab_data == 1">
          <div class="imgPreview">
            <div id="prompt3">
              <input
                type="file"
                id="file"
                class="filepath"
                @change="changepic('file')"
                accept="image/jpg,image/jpeg,image/png,image/PNG"
              />
              <!--当vaule值改变时执行changepic函数，规定上传的文件只能是图片-->
            </div>
            <img :src="usermsg.face_new" id="img3" />
            <div v-if="loading" class="loading">上传中...</div>
            <div class="exitface">
              <div class="">
                <i class="iconfont2">&#xe639;</i>
              </div>
              <div class="">修改头像</div>
            </div>
          </div>
          <dl>
            <dt>昵称：</dt>
            <dd><input type="text" v-model="usermsg.user_name" /></dd>
            <dt>手机号码：</dt>
            <dd>
              <input type="text" :value="telphone_number" disabled="disabled" />
            </dd>
            <dt>个性签名：</dt>
            <dd>
              <textarea
                name=""
                placeholder="最多可输入40字"
                v-model="usermsg.enounce"
              ></textarea>
            </dd>
          </dl>
          <div class="save" @click="saveFn()">保存</div>
        </div>
        <div class="user_msg" v-show="tab == 1 && tab_data == 2">
          <dl>
            <dt>微信号：</dt>
            <dd>
              <input
                type="text"
                v-model="usermsg.wx_num"
                placeholder="请输入微信号"
              />
            </dd>
            <dt>二维码：</dt>
            <dd>
              <div class="imgPreview_wx">
                <div class="prompt_wx">
                  <input
                    type="file"
                    id="wx"
                    class="filepath"
                    @change="changepic('wx')"
                    accept="image/jpg,image/jpeg,image/png,image/PNG"
                  />
                  <!--当vaule值改变时执行changepic函数，规定上传的文件只能是图片-->
                </div>
                <img
                  :src="
                    usermsg.wx_code
                      ? usermsg.wx_code
                      : 'https://static.jiil1.com/gqj_tv/image/upload.png'
                  "
                  class="img_wx"
                />
                <div v-if="loading_wx" class="loading loading_wx">
                  上传中...
                </div>
                <div class="exitface">
                  <div class="i">
                    <i class="iconfont2">&#xe639;</i>
                  </div>
                  <div class="">
                    {{ usermsg.wx_code ? "修改二维码" : "上传二维码" }}
                  </div>
                </div>
              </div>
            </dd>
          </dl>
          <div class="save save_wx" @click="saveFn()">保存</div>
        </div>
        <div class="user_msg" v-show="tab == 2 && verify == 4">
          <dl>
            <dt>真实姓名：</dt>
            <dd>
              <input
                type="text"
                v-model="anchormsg.name"
                placeholder="请填写您的真实姓名"
              />
            </dd>
            <dt>身份证号码：</dt>
            <dd>
              <input
                type="text"
                v-model="anchormsg.card_id"
                placeholder="请填写您的身份证号码"
              />
            </dd>
            <dt>QQ/微信：</dt>
            <dd>
              <input
                type="text"
                v-model="anchormsg.contact_num"
                placeholder="请填写您的QQ/微信（示例：QQ-2536332145）"
              />
            </dd>
          </dl>
          <div class="card_title">身份证验证：</div>
          <div class="card_img" ref="card_img">
            <div>
              <div class="img_front" ref="front_div">
                <div class="prompt">
                  <input
                    type="file"
                    id="front"
                    class="filepath"
                    @change="changepic('front')"
                    accept="image/jpg,image/jpeg,image/png,image/PNG"
                  />
                  <!--当vaule值改变时执行changepic函数，规定上传的文件只能是图片-->
                </div>
                <div v-if="frontloading" class="loading">
                  <span>上传中...</span>
                </div>
                <img
                  :src="
                    anchormsg.card_img_front
                      ? anchormsg.card_img_front
                      : 'https://static.jiil1.com/static/image/card_img_front.png'
                  "
                  ref="front"
                  alt=""
                />
                <div
                  v-if="anchormsg.card_img_front"
                  class="close"
                  @click="closepic('front')"
                >
                  <i class="iconfont2">&#xe62f;</i>
                </div>
              </div>
              <div class="title">上传身份证正面</div>
            </div>
            <div>
              <div class="img_front" ref="obverse">
                <div class="prompt">
                  <input
                    type="file"
                    id="obverse"
                    class="filepath"
                    @change="changepic('obverse')"
                    accept="image/jpg,image/jpeg,image/png,image/PNG"
                  />
                  <!--当vaule值改变时执行changepic函数，规定上传的文件只能是图片-->
                </div>
                <div v-if="obverseloading" class="loading">
                  <span>上传中...</span>
                </div>
                <img
                  :src="
                    anchormsg.card_img_obverse
                      ? anchormsg.card_img_obverse
                      : 'https://static.jiil1.com/static/image/card_img_obverse.png'
                  "
                  alt=""
                />
                <div
                  v-if="anchormsg.card_img_obverse"
                  class="close"
                  @click="closepic('obverse')"
                >
                  <i class="iconfont2">&#xe62f;</i>
                </div>
              </div>
              <div class="title">上传身份证反面</div>
            </div>
            <!--<div>
							<div class="img_front" ref="holding">
							 	<div class="prompt">
							 		<input type="file" id="holding" class="filepath" @change="changepic('holding')" accept="image/jpg,image/jpeg,image/png,image/PNG">
							 	</div>
							 	<div v-if="holdingloading" class="loading"><span>上传中...</span></div>
							 	<img :src="anchormsg.card_img_holding?anchormsg.card_img_holding:'https://static.jiil1.com/static/image/card_img_holding.png'" alt=""/>
							 	<div v-if="anchormsg.card_img_holding" class="close" @click="closepic('holding')"><i class="iconfont2">&#xe62f;</i></div>
							</div>
							<div class="title">
								上传手持身份证照片
							</div>
						</div>-->
          </div>
          <div class="user_tip">
            温馨提示：请确保姓名、身份证号清晰可见，这可以帮助客服人员快速通过您的申请
          </div>
          <div class="protocol">
            <i class="xieyi_cicle" v-show="!agree" @click="agree = 1"></i>
            <i class="iconfont2" v-show="agree" @click="agree = 0">&#xe633;</i>
            <span>我已阅读并同意</span>
            <a href="/anchorProtocol" target="_blank">《逛球街主播协议》</a>
          </div>
          <div class="save" @click="anchorsaveFn()">保存</div>
        </div>
        <!--审核成功-->
        <div class="user_msg" v-if="tab == 2 && verify == 1">
          <div class="verify">
            <div>
              <img
                src="//static.jiil1.com/static/image/verify_success.png"
                width="244px"
              />
            </div>
            <div>恭喜成为主播！</div>
            <div>审核通过，直播请遵守网络直播协议。</div>
            <div @click="tab = 4" class="liveBtn">
              <i class="iconfont2">&#xe63c;</i>
              <span>开始直播</span>
            </div>
          </div>
        </div>
        <!--审核中-->
        <div class="user_msg" v-if="tab == 2 && verify == 2">
          <div class="verify">
            <div>
              <img
                src="//static.jiil1.com/static/image/verify.png"
                width="244px"
              />
            </div>
            <div>审核中...</div>
            <div>提交成功，工作人员将会尽快审核 并告知审核结果。。</div>
          </div>
        </div>
        <!--审核失败-->
        <div class="user_msg" v-if="tab == 2 && verify == 3">
          <div class="verify">
            <div>
              <img
                src="//static.jiil1.com/static/image/verify_fail.png"
                width="244px"
              />
            </div>
            <div>审核失败！</div>
            <div>{{ verifymsg ? verifymsg : "请重新提交申请资料。" }}</div>
            <div
              @click="
                tab = 2;
                verify = 4;
              "
              class="reloadBtn"
            >
              重新填写
            </div>
          </div>
        </div>
        <!--开播教程-->
        <div class="user_msg course" v-if="tab == 3">
          <h3>开播教程</h3>
          <div>
            1、登录完成之后，你的昵称就是主播名，确认无误之后打开OBS(备注:<a
              href="https://obsproject.com/zh-cn/download"
              target="_blank"
              >OBS下载</a
            >)
          </div>
          <div class="img">
            <img
              src="https://static.jiil1.com/gqj_tv/image/course/01.png"
              alt=""
            />
          </div>
          <div>
            2、obs操作步骤：<br />
            &emsp;&ensp;1）、打开obs工具，右下角点击“设置”，如图所示选中“推流”，（第一行默认，第二行服务器输入：rtmp://push.xxxx.com/live/主播<br />
            &emsp;&ensp;名称全拼、比如我是小可乐链接就是rtmp://push.xxxx.com/live/xiaokele，第三行窜流密钥输入主播名称全拼、如主播名字是小可乐那就<br />
            &emsp;&ensp;输入：xiaokele，点击确定，关闭当前页面
          </div>
          <div class="OBSimg">
            <img
              src="https://static.jiil1.com/gqj_tv/image/course/1.png"
              alt=""
            />
            <img
              src="https://static.jiil1.com/gqj_tv/image/course/2.png"
              alt=""
            />
            <img
              src="https://static.jiil1.com/gqj_tv/image/course/3.png"
              alt=""
            />
            <img
              src="https://static.jiil1.com/gqj_tv/image/course/4.png"
              alt=""
            />
            <img
              src="https://static.jiil1.com/gqj_tv/image/course/5.png"
              alt=""
            />
            <img
              src="https://static.jiil1.com/gqj_tv/image/course/6.png"
              alt=""
            />
            <img
              src="https://static.jiil1.com/gqj_tv/image/course/7.png"
              alt=""
            />
            <img
              src="https://static.jiil1.com/gqj_tv/image/course/8.png"
              alt=""
            />
            <img
              src="https://static.jiil1.com/gqj_tv/image/course/9.png"
              alt=""
            />
            <img
              src="https://static.jiil1.com/gqj_tv/image/course/10.png"
              alt=""
            />
            <img
              src="https://static.jiil1.com/gqj_tv/image/course/11.png"
              alt=""
            />
            <img
              src="https://static.jiil1.com/gqj_tv/image/course/12.png"
              alt=""
            />
          </div>
          <div>
            3、逛球街pc推流码&ensp;rtmp://hls.xxxx.com/live/名字拼音（就是填你在逛球街的昵称，比如我是小可乐，那我就填xiaokele）<br />
            &emsp;&ensp;填好之后调整好截屏，文字，二维码等等，点击开始串流，然后点击你排上的赛程的那场比赛的2D或视频
          </div>
          <div class="img">
            <img
              src="https://static.jiil1.com/gqj_tv/image/course/03.png"
              alt=""
            />
          </div>
          <div>4、首先我们可以看到在视频直播旁边有个申请开播点击</div>
          <div class="img">
            <img
              src="https://static.jiil1.com/gqj_tv/image/course/04.png"
              alt=""
            />
          </div>
          <div>4、首先我们可以看到在视频直播旁边有个申请开播</div>
          <div class="img">
            <img
              src="https://static.jiil1.com/gqj_tv/image/course/05.png"
              alt=""
            />
          </div>
          <div>
            6、最后在下播的时候，鼠标移到自己的头像，把自己的推流删了点击提交，<br />
            &emsp;&ensp;刷新后看不到自己直播间了就可以下播了，包括你连播的比赛也是要把上一场比赛推流删了换下一场比赛。
          </div>
          <div class="img">
            <img
              src="https://static.jiil1.com/gqj_tv/image/course/06.png"
              alt=""
            />
          </div>
          <div>7、停止推流</div>
          <div class="img">
            <img
              src="https://static.jiil1.com/gqj_tv/image/course/07.png"
              alt=""
            />
          </div>
          <div class="end1">下播的时候记得删除推流码</div>
          <div class="end2">注意：下播点击网页</div>
        </div>
        <!--开始直播-->
        <div class="user_msg anchor" v-if="tab == 4">
          <dl>
            <dt><span>*</span>赛事类型：</dt>
            <dd>
              <select name="" v-model="anchorlive.category">
                <option value="" disabled selected>选择类型</option>
                <option :value="key" v-for="(item, key) in nav">
                  {{ item }}
                </option>
              </select>
            </dd>
            <dt><span>*</span>联赛名称：</dt>
            <dd><input type="text" v-model="anchorlive.league" /></dd>
            <dt><span>*</span>开赛时间：</dt>
            <dd>
              <el-date-picker
                v-model="anchorlive.start_time"
                type="datetime"
                placeholder="选择开播时间"
              >
              </el-date-picker>
            </dd>
            <dt><span>*</span>主队名称：</dt>
            <dd><input type="text" v-model="anchorlive.home_team_zh" /></dd>
            <dt><span>*</span>主队logo：</dt>
            <dd>
              <div class="logoprompt">
                <input
                  type="file"
                  id="homelogo"
                  class="filepath"
                  @change="changepic('homelogo')"
                  accept="image/jpg,image/jpeg,image/png,image/PNG"
                />
                <!--当vaule值改变时执行changepic函数，规定上传的文件只能是图片-->
              </div>
              <div v-if="homelogoloading" class="loading">
                <span>上传中...</span>
              </div>
              <img
                :src="
                  anchorlive.home_logo
                    ? anchorlive.home_logo
                    : 'https://static.jiil1.com/gqj_live/image/teamlogo.png'
                "
                alt=""
              />
            </dd>
            <dt><span>*</span>客队名称：</dt>
            <dd><input type="text" v-model="anchorlive.away_team_zh" /></dd>
            <dt><span>*</span>客队logo：</dt>
            <dd>
              <div class="logoprompt">
                <input
                  type="file"
                  id="awaylogo"
                  class="filepath"
                  @change="changepic('awaylogo')"
                  accept="image/jpg,image/jpeg,image/png,image/PNG"
                />
                <!--当vaule值改变时执行changepic函数，规定上传的文件只能是图片-->
              </div>
              <div v-if="awaylogoloading" class="loading">
                <span>上传中...</span>
              </div>
              <img
                :src="
                  anchorlive.away_logo
                    ? anchorlive.away_logo
                    : 'https://static.jiil1.com/gqj_live/image/teamlogo.png'
                "
                alt=""
              />
            </dd>
<!--            <dt>视频流地址：</dt>-->
<!--           <dd><input type="text" v-model="anchorlive.url" /></dd>&ndash;&gt;-->
<!--            <dd>{{anchorlive.url}}</dd>-->
          </dl>
          <div>
            <div class="anchorsave" @click="OPlayerFn()">
              {{ savebtn ? "修改" : "开播" }}
            </div>
            <div class="liveclose" @click="livecloseFn()" v-if="savebtn">
              下播
            </div>
          </div>
        </div>
        <!--我的关注-->
        <div class="tab" v-show="tab == 5">
          <span
            :class="follow_data != 2 ? 'active' : ''"
            @click="follow_data = 1"
            >我的关注</span
          ><span
            :class="follow_data == 2 ? 'active' : ''"
            @click="follow_data = 2"
            v-if="userType == 2"
            >我的粉丝</span
          >
          <div
            :class="'line tabData' + follow_data"
            :style="'left:' + ((follow_data - 1) * 100 + 49) + 'px'"
          ></div>
        </div>
        <div class="user_msg user_follow" v-show="tab == 5 && follow_data == 1">
          <div class="follow_alert" v-if="follow_alert">
            {{ follow_alert }}
          </div>
          <div class="nofollow" v-if="follow.list.length == 0">
            <img
              src="https://static.jiil1.com/gqj_tv/image/nofollow.png"
              alt=""
            />
          </div>
          <div class="follow_outer" v-if="follow.list.length > 0">
            <div class="follow" v-for="(item, index) in follow.list">
              <div class="anchor">
                <img :src="item.face" alt="" />
                <span>{{ item.username }}</span>
              </div>
              <div
                :class="item.nofollow ? 'follow_btn' : 'follow_btn active'"
                v-html="follow_html(item.nofollow)"
                @click="follow_bind_Unbound(item, index)"
              ></div>
            </div>
          </div>
          <div class="pagination" v-if="follow.list.length > 0">
            <el-pagination
              @current-change="follow_handleCurrentChange"
              :current-page="follow.currentPage"
              :page-size="10"
              layout="prev, pager, next, jumper,total"
              :total="follow.totalSize"
            >
            </el-pagination>
          </div>
        </div>
        <div class="user_msg user_fans" v-show="tab == 5 && follow_data == 2">
          <div class="follow_alert" v-if="follow_alert">
            {{ follow_alert }}
          </div>
          <div class="nofollow" v-if="fans.list.length == 0">
            <img
              src="https://static.jiil1.com/gqj_tv/image/nofans.png"
              alt=""
            />
          </div>
          <div class="follow_outer" v-if="fans.list.length > 0">
            <div class="follow" v-for="(item, index) in fans.list">
              <div class="anchor">
                <img :src="item.face" alt="" />
                <span>{{ item.username }}</span>
              </div>
              <!--<div :class="item.nofollow?'follow_btn':'follow_btn active'" v-html="follow_html(item.nofollow)" v-if="item.type==2" @click="follow_bind_Unbound(item, index)"></div>-->
            </div>
          </div>
          <div class="pagination" v-if="fans.list.length > 0">
            <el-pagination
              @current-change="fans_handleCurrentChange"
              :current-page="fans.currentPage"
              :page-size="10"
              layout="prev, pager, next, jumper,total"
              :total="fans.totalSize"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as qiniu from "qiniu-js";
import axios from "axios";
export default {
  props: ["exitshow", "qiniutoken"],
  data() {
    return {
      usermsg: {
        user_name: "",
        wx_num: "",
        wx_code: "",
        face: "",
        face_new: "",
        enounce: "",
      },
      anchormsg: {
        name: "",
        card_id: "",
        contact_num: "",
        card_img_front: "",
        card_img_obverse: "",
        card_img_holding: "",
      },
      anchormsgtwo: {
        name: "",
        card_id: "",
        contact_num: "",
        card_img_front: "",
        card_img_obverse: "",
        card_img_holding: "",
      },
      anchorlive: {
        category: "",
        league: "",
        start_time: "",
        home_team_zh: "",
        home_logo: "",
        away_team_zh: "",
        away_logo: "",
        url: "",
      },
      anchorlivetwo: {
        category: "",
        league: "",
        start_time: "",
        home_team_zh: "",
        home_logo: "",
        away_team_zh: "",
        away_logo: "",
        url: "",
      },
      nav: {
        1: "其他",
        2: "网球",
        3: "排球",
        4: "台球",
        5: "羽毛球",
        18: "电竞",
      },
      savebtn: 0,
      hit: "",
      minHeight: "789px",
      userType: 1,
      agree: 0,
      tab: 1,
      tab_data: 1,
      follow_data: 1,
      verify: 4,
      verifymsg: "",
      telphone_number: "",
      token: "",
      loading: 0,
      loading_wx: 0,
      frontloading: 0,
      obverseloading: 0,
      holdingloading: 0,
      homelogoloading: 0,
      awaylogoloading: 0,
      playing: 0,
      follow: {
        list: [],
        currentPage: 1,
        totalSize: 0,
      },
      currfollow: {},
      currindex: 0,
      follow_alert: "",
      follow_Unbound_alert: 0,
      fans: {
        list: [],
        currentPage: 1,
        totalSize: 0,
      },
    };
  },

  watch: {
    "usermsg.user_name"(newVal) {
      if (newVal.length > 14) {
        this.usermsg.user_name = newVal.slice(0, 14);
      }
    },
    "usermsg.enounce"(newVal) {
      if (newVal.length > 200) {
        this.usermsg.enounce = newVal.slice(0, 200);
      }
    },
    "usermsg.wx_num"(newVal) {
      if (newVal.length > 18) {
        this.usermsg.wx_num = newVal.slice(0, 18);
      }
    },
    exitshow(newVal) {
      if (newVal) {
        if (this.getCookie("token")) {
          this.tab = newVal;
          this.getuserinfo();
          this.getInfo();
          this.getAnchor();
          this.getFans();
        } else {
          localStorage.setItem("minfo", "{}");
          window.location.reload();
          //						this.callParentClose();
        }
      }
    },
    "anchormsg.name"(newVal) {
      if (newVal.length > 20) {
        this.anchormsg.name = newVal.slice(0, 20);
      }
    },
    "anchormsg.contact_num"(newVal) {
      if (newVal.length > 30) {
        this.anchormsg.contact_num = newVal.slice(0, 30);
      }
    },
    "anchormsg.card_id"(newVal) {
      var card = /^[xX0-9]+$/;
      if (!card.test(newVal)) {
        this.anchormsg.card_id = newVal.slice(0, newVal.length - 1);
      }
    },
    "anchorlive.league"(newVal) {
      if (newVal.length > 30) {
        this.hitFn("联赛名称最多30个字");
        this.anchorlive.league = newVal.slice(0, 30);
      }
    },
    tab(newVal) {
      if (newVal == 2 && this.verify == 4) {
        this.$nextTick(function () {
          this.$refs["front_div"].style.height =
            this.$refs["front"].width * (130 / 227) + "px";
          this.$refs["obverse"].style.height =
            this.$refs["front"].width * (130 / 227) + "px";
          //						this.$refs['holding'].style.height = this.$refs['front'].width*(130/227)+"px";
          this.$refs["card_img"].style.height =
            this.$refs["front"].width * (130 / 227) + 25 + "px";
        });
      }
      if (newVal == 4) {
        this.getlive();
      }
      if (newVal == 5) {
        if ($(".user_fans .el-pagination__confirm").length == 0) {
          $(".user_fans .el-pagination__total").before(
            '<span class="el-pagination__confirm">确定</span>'
          );
        } else if ($(".user_follow .el-pagination__confirm").length == 0) {
          $(".user_follow .el-pagination__total").before(
            '<span class="el-pagination__confirm">确定</span>'
          );
        }
      }
    },
    verify(newVal) {
      if (newVal == 4) {
        this.$nextTick(function () {
          this.$refs["front_div"].style.height =
            this.$refs["front"].width * (130 / 227) + "px";
          this.$refs["obverse"].style.height =
            this.$refs["front"].width * (130 / 227) + "px";
          //						this.$refs['holding'].style.height = this.$refs['front'].width*(130/227)+"px";
          this.$refs["card_img"].style.height =
            this.$refs["front"].width * (130 / 227) + 25 + "px";
        });
      }
    },
  },
  mounted() {
    this.usermsg = {
      user_name: decodeURI(this.getCookie("userName")),
      wx_code: this.getCookie("wx_code"),
      wx_num: this.getCookie("wx_num"),
      face: this.getCookie("face"),
      face_new: this.getCookie("face"),
      enounce: this.getCookie("enounce")
        ? decodeURI(this.getCookie("enounce"))
        : "",
      type: this.getCookie("type"),
    };
    this.telphone_number = this.getCookie("telphone_number");
    //			this.minHeight = (window.innerHeight-110)+'px';

    if ($(window).height() - 110 <= 789) {
      this.minHeight = "789px";
    } else {
      this.minHeight = $(window).height() - 110 + "px";
    }
    if (this.getCookie("token") && !this.qiniutoken) {
      this.getQiniuToken();
    }
    if (this.getCookie("token")) {
      this.getuserinfo();
    } else {
      localStorage.setItem("minfo", "{}");
    }
  },
  methods: {
    callParentClose() {
      this.$emit("exituser", "", true);
    },
    getQiniuToken() {
      var headers = {
        Authorization: this.getCookie("token"),
      };
      axios
        .get(COMMOND.NEW_BASE_URL + "qiniu/token", {
          headers: headers,
        })
        .then((res) => {
          this.token = res.data.data.token;
        });
    },
    //修改用户信息
    saveFn() {
      var data = {};
      if (this.usermsg.user_name == "") {
        this.hitFn("昵称不可为空");
        return;
      }
      if (
        this.usermsg.user_name != decodeURI(this.getCookie("userName")) &&
        this.usermsg.user_name.trim() != ""
      ) {
        data.user_name = this.usermsg.user_name;
      }
      if (this.usermsg.face_new != this.getCookie("face")) {
        data.face = this.usermsg.face_new;
      }
      //				if(this.usermsg.enounce.length<2) {
      //					this.hitFn("个性签名不可少于2个字！");
      //					return;
      //				}
      data.enounce = this.usermsg.enounce;
      if (this.usermsg.wx_num != this.getCookie("wx_num")) {
        data.wx_num = this.usermsg.wx_num;
        if (data.wx_num.length < 6 && this.usermsg.wx_num.trim() != "") {
          layer.msg("微信号不可小于6位！");
          return;
        }
      }
      if (this.usermsg.wx_code != this.getCookie("wx_code")) {
        data.wx_code = this.usermsg.wx_code;
      }
      if (
        !data.user_name &&
        !data.face &&
        data.enounce == decodeURI(this.getCookie("enounce")) &&
        this.usermsg.wx_num == this.getCookie("wx_num") &&
        !data.wx_code
      ) {
        this.hitFn("无修改内容");
        return;
      }
      var token = this.getCookie("token");
      axios
        .post(COMMOND.NEW_BASE_URL + "update_user", data, {
          headers: {
            Authorization: token,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.setCookie("userName", encodeURI(this.usermsg.user_name));
            this.setCookie("face", this.usermsg.face_new);
            this.setCookie("enounce", encodeURI(this.usermsg.enounce));
            this.setCookie("wx_num", this.usermsg.wx_num);
            this.setCookie("wx_code", this.usermsg.wx_code);
            this.usermsg.face = this.usermsg.face_new;
            this.$emit("usermsg", this.usermsg, true);
            this.hitFn("修改成功");
          } else {
            this.hitFn(res.data.msg);
          }
        });
    },
    getuserinfo() {
      var token = this.getCookie("token");
      axios
        .get(COMMOND.NEW_BASE_URL + "get_user_info", {
          headers: {
            Authorization: token,
          },
        })
        .then((res) => {
          var data = res.data;
          if (data.code == 200) {
            console.info("dispatch");
            this.$store.dispatch("setMemberInfo", data.data);
            localStorage.setItem("minfo", JSON.stringify(data.data));
            data.data.enounce =
              data.data.enounce == null || data.data.enounce == "null"
                ? ""
                : data.data.enounce;
            this.setCookie("telphone_number", data.data.mobile);
            this.setCookie("userName", encodeURI(data.data.username));
            this.setCookie("member_id", data.data.member_id);
            this.setCookie("type", data.data.type);
            this.setCookie("enounce", encodeURI(data.data.enounce));
            this.setCookie("face", data.data.face);
            this.setCookie("netease_im_token", data.data.netease_im_token);
            this.setCookie("wx_num", data.data.wx_num);
            this.setCookie("wx_code", data.data.wx_code);
            this.userType = data.data.type;
            this.usermsg = {
              user_name: data.data.username,
              wx_num: data.data.wx_num,
              wx_code: data.data.wx_code,
              face: data.data.face,
              face_new: data.data.face,
              enounce: data.data.enounce,
              type: data.data.type,
            };
            this.telphone_number = data.data.mobile;
            //						if((data.data.type==2||data.data.type==9)&&this.tab==3){
            //							this.getlive();
            //						}
            this.$emit("usermsg", this.usermsg, true);
          }
        });
    },
    follow_alert_fn(msg) {
      var that = this;
      this.follow_alert = msg;
      setTimeout(function () {
        that.follow_alert = "";
      }, 1500);
    },
    follow_html(type) {
      if (type) {
        return '<span class="follow_add">+</span><span>关注</span>';
      }
      return "已关注";
    },
    follow_bind_Unbound(item, index) {
      if (item.nofollow) {
        this.follow_Unbound(item, index);
      } else {
        this.currfollow = item;
        (this.currindex = index), (this.follow_Unbound_alert = 1);
      }
    },
    follow_Unbound(item, index) {
      var token = this.getCookie("token");
      axios
        .post(
          COMMOND.NEW_BASE_URL + "follow_anchor",
          {
            member_id: item.member_id,
            is_follow: item.nofollow,
          },
          {
            headers: {
              Authorization: token,
            },
          }
        )
        .then((res) => {
          if (res.data.code == 200) {
            if (item.nofollow) {
              this.follow.list[index].nofollow = 0;
              this.follow_alert_fn("关注成功");
            } else {
              this.follow_Unbound_alert = 0;
              this.follow.list[index].nofollow = 1;
              this.follow_alert_fn("取消关注成功");
            }
          } else {
            this.follow_alert_fn(res.data.msg);
          }
        });
    },
    getAnchor() {
      var token = this.getCookie("token");
      axios
        .get(
          COMMOND.NEW_BASE_URL +
            "follow_anchor_list?page=" +
            this.follow.currentPage,
          {
            headers: {
              Authorization: token,
            },
          }
        )
        .then((res) => {
          for (var i = 0; i < res.data.data.list.length; i++) {
            res.data.data.list[i].nofollow = 0;
          }
          this.follow.list = [];
          if (res.data.data.list.length == 0 && this.follow.currentPage > 1) {
            this.follow.currentPage--;
            this.getAnchor();
          } else {
            this.follow.list = res.data.data.list;
            this.follow.totalSize = res.data.data.count;
          }
          this.$nextTick(function () {
            if ($(".user_follow .el-pagination__confirm").length == 0) {
              $(".user_follow .el-pagination__total").before(
                '<span class="el-pagination__confirm">确定</span>'
              );
            }
          });
        });
    },
    follow_handleCurrentChange(data) {
      if (this.follow.currentPage != data) {
        this.follow.currentPage = data;
        this.getAnchor();
      }
    },
    getFans() {
      var token = this.getCookie("token");
      axios
        .get(COMMOND.NEW_BASE_URL + "fans_list?page=" + this.fans.currentPage, {
          headers: {
            Authorization: token,
          },
        })
        .then((res) => {
          var data = res.data;
          for (var i = 0; i < data.data.list.length; i++) {
            data.data.list[i].nofollow = 0;
          }
          this.fans.list = [];
          if (data.data.list.length == 0 && this.fans.currentPage > 1) {
            this.fans.currentPage--;
            this.getFans();
          } else {
            this.fans.list = data.data.list;
            this.fans.totalSize = data.data.count;
          }
          this.$nextTick(function () {
            if ($(".user_fans .el-pagination__confirm").length == 0) {
              $(".user_fans .el-pagination__total").before(
                '<span class="el-pagination__confirm">确定</span>'
              );
            }
          });
        });
    },
    fans_handleCurrentChange(data) {
      if (this.fans.currentPage != data) {
        this.fans.currentPage = data;
        this.getFans();
      }
    },
    getlive() {
      var token = this.getCookie("token");
      axios
        .get(COMMOND.NEW_BASE_URL + "get_live", {
          headers: {
            Authorization: token,
          },
        })
        .then((res) => {
          var data = res.data;
          if (data.code == 200) {
            this.anchorlive = {
              category: data.data.category,
              league: data.data.league,
              start_time: data.data.start_time,
              home_team_zh: data.data.home_team_zh,
              home_logo: data.data.home_logo,
              away_team_zh: data.data.away_team_zh,
              away_logo: data.data.away_logo,
              url: data.data.url,
            };
            this.anchorlivetwo = {
              category: data.data.category,
              league: data.data.league,
              start_time: data.data.start_time,
              home_team_zh: data.data.home_team_zh,
              home_logo: data.data.home_logo,
              away_team_zh: data.data.away_team_zh,
              away_logo: data.data.away_logo,
              url: data.data.url,
            };
            if (data.data.league) {
              this.savebtn = 1;
            } else {
              this.savebtn = 0;
            }
          }
        });
    },
    getInfo() {
      var token = this.getCookie("token");
      axios
        .get(COMMOND.NEW_BASE_URL + "get_applications_info", {
          headers: {
            Authorization: token,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            var data = res.data.data;
            this.verify = data.status;
            this.verifymsg = data.msg;
            this.anchormsg = {
              name: data.name ? data.name : "",
              card_id: data.card_id ? data.card_id : "",
              contact_num: data.contact_num ? data.contact_num : "",
              card_img_front: data.card_img_front ? data.card_img_front : "",
              card_img_obverse: data.card_img_obverse
                ? data.card_img_obverse
                : "",
              card_img_holding: data.card_img_holding
                ? data.card_img_holding
                : "",
            };
            this.anchormsgtwo = {
              name: data.name ? data.name : "",
              card_id: data.card_id ? data.card_id : "",
              contact_num: data.contact_num ? data.contact_num : "",
              card_img_front: data.card_img_front ? data.card_img_front : "",
              card_img_obverse: data.card_img_obverse
                ? data.card_img_obverse
                : "",
              card_img_holding: data.card_img_holding
                ? data.card_img_holding
                : "",
            };
          } else {
            console.log("获取审核资料失败");
          }
        });
    },
    anchorsaveFn() {
      var that = this;
      var token = this.getCookie("token");
      var data = {};
      if (this.anchormsg.name != "" && this.anchormsg.name.length >= 2) {
        //					if(this.anchormsg.name != this.anchormsgtwo.name){
        data.name = this.anchormsg.name;
        //					}
      } else {
        this.hitFn("请填写您的真实姓名,不可少于2个字");
        return;
      }
      if (this.anchormsg.card_id != "") {
        var card = /^\d{17}(\d|x|X)$/;
        if (!card.test(this.anchormsg.card_id)) {
          this.hitFn("输入身份证号码格式有误");
          return;
        }
        //					if(this.anchormsg.card_id != this.anchormsgtwo.card_id){
        data.card_id = this.anchormsg.card_id;
        //					}
      } else {
        this.hitFn("请填写您的身份证号码");
        return;
      }
      if (this.anchormsg.contact_num != "") {
        //					if(this.anchormsg.contact_num != this.anchormsgtwo.contact_num){
        data.contact_num = this.anchormsg.contact_num;
        //					}
      } else {
        this.hitFn("请填写您的QQ/微信");
        return;
      }
      if (this.anchormsg.card_img_front != "") {
        //					if(this.anchormsg.card_img_front != this.anchormsgtwo.card_img_front){
        data.card_img_front = this.anchormsg.card_img_front;
        //					}
      } else {
        this.hitFn("请上传身份证正面 ");
        return;
      }
      if (this.anchormsg.card_img_obverse != "") {
        //					if(this.anchormsg.card_img_obverse != this.anchormsgtwo.card_img_obverse){
        data.card_img_obverse = this.anchormsg.card_img_obverse;
        //					}
      } else {
        this.hitFn("请上传身份证反面");
        return;
      }
      //				if(this.anchormsg.card_img_holding != "") {
      ////					if(this.anchormsg.card_img_holding != this.anchormsgtwo.card_img_holding){
      //						data.card_img_holding = this.anchormsg.card_img_holding;
      ////					}
      //				}else {
      //					this.hitFn("请上传手持身份证照片");
      //					return;
      //				}
      if (!this.agree) {
        this.hitFn("请阅读并同意《球坛主播协议》！");
        return;
      }
      axios
        .post(COMMOND.NEW_BASE_URL + "anchor_application", data, {
          headers: {
            Authorization: token,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            //		    			this.getInfo();
            this.hitFn("提交申请成功");
            this.verify = 2;
            this.usermsg = {
              user_name: decodeURI(this.getCookie("userName")),
              wx_num: this.getCookie("wx_num"),
              wx_code: this.getCookie("wx_code"),
              face: this.getCookie("face"),
              face_new: this.getCookie("face"),
              enounce: this.getCookie("enounce")
                ? decodeURI(this.getCookie("enounce"))
                : "",
              type: this.getCookie("type"),
            };
          } else {
            this.hitFn(res.data.msg);
          }
        })
        .catch(function (err) {
          if (err.response.status == 422) {
            var data = err.response.data;
            var msg = "";
            for (var key in data) {
              msg = data[key][0];
              break;
            }
            that.hitFn(msg);
          }
        });
    },
    OPlayerFn() {
      if (this.playing) {
        this.hitFn("请勿重复点击");
        return;
      } else {
        this.playing = 1;
      }
      var that = this;
      var token = this.getCookie("token");
      var data = {};
      if (this.anchorlive.category) {
        //					if(this.anchorlive.category != this.anchorlivetwo.category){
        data.category = this.anchorlive.category;
        //					}
      } else {
        this.hitFn("请选择赛事类型");
        this.playing = 0;
        return;
      }
      if (this.anchorlive.league && this.anchorlive.league.length >= 2) {
        //					if(this.anchorlive.league != this.anchorlivetwo.league){
        data.league = this.anchorlive.league;
        //					}
      } else {
        this.hitFn("联赛名称至少两个字符");
        this.playing = 0;
        return;
      }
      if (this.anchorlive.start_time) {
        //					if(this.anchorlive.start_time != this.anchorlivetwo.start_time){
        data.start_time = this.anchorlive.start_time;
        //					}
      } else {
        this.hitFn("请填写开赛时间");
        this.playing = 0;
        return;
      }
      if (this.anchorlive.home_team_zh) {
        //					if(this.anchorlive.home_team_zh != this.anchorlivetwo.home_team_zh){
        data.home_team_zh = this.anchorlive.home_team_zh;
        //					}
      } else {
        this.hitFn("请填写主队名称 ");
        this.playing = 0;
        return;
      }
      if (this.anchorlive.home_logo) {
        //					if(this.anchorlive.home_logo != this.anchorlivetwo.home_logo){
        data.home_logo = this.anchorlive.home_logo;
        //					}
      } else {
        this.hitFn("请上传主队logo");
        this.playing = 0;
        return;
      }
      if (this.anchorlive.away_team_zh) {
        //					if(this.anchorlive.away_team_zh != this.anchorlivetwo.away_team_zh){
        data.away_team_zh = this.anchorlive.away_team_zh;
        //					}
      } else {
        this.hitFn("请填写客队名称");
        this.playing = 0;
        return;
      }
      if (this.anchorlive.away_logo) {
        //					if(this.anchorlive.away_logo != this.anchorlivetwo.away_logo){
        data.away_logo = this.anchorlive.away_logo;
        //					}
      } else {
        this.hitFn("请填写客队logo");
        this.playing = 0;
        return;
      }
      // if (this.anchorlive.url) {
      //   //					if(this.anchorlive.url != this.anchorlivetwo.url){
      //   data.url = this.anchorlive.url;
      //   //					}
      // } else {
      //   this.hitFn("请填写视频流地址");
      //   this.playing = 0;
      //   return;
      // }
      if (
        this.anchorlive.category == this.anchorlivetwo.category &&
        this.anchorlive.league == this.anchorlivetwo.league &&
        this.anchorlive.start_time == this.anchorlivetwo.start_time &&
        this.anchorlive.home_team_zh == this.anchorlivetwo.home_team_zh &&
        this.anchorlive.home_logo == this.anchorlivetwo.home_logo &&
        this.anchorlive.away_team_zh == this.anchorlivetwo.away_team_zh &&
        this.anchorlive.away_logo == this.anchorlivetwo.away_logo
      ) {
        this.hitFn("无修改内容");
        this.playing = 0;
        return;
      }
      axios
        .post(COMMOND.NEW_BASE_URL + "create_live", data, {
          headers: {
            Authorization: token,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.savebtn = 1;
            if (this.anchorlivetwo.league) {
              this.hitFn("修改成功");
            } else {
              this.hitFn("开播成功");
            }
            this.anchorlivetwo = {
              category: this.anchorlive.category,
              league: this.anchorlive.league,
              start_time: this.anchorlive.start_time,
              home_team_zh: this.anchorlive.home_team_zh,
              home_logo: this.anchorlive.home_logo,
              away_team_zh: this.anchorlive.away_team_zh,
              away_logo: this.anchorlive.away_logo,
              url: this.anchorlive.url,
            };
          } else {
            this.hitFn(res.data.msg);
          }
          this.playing = 0;
        })
        .catch(function (err) {
          if (err.response.status == 422) {
            var data = err.response.data;
            var msg = "";
            for (var key in data) {
              msg = data[key][0];
              break;
            }
            that.hitFn(msg);
          }
          that.playing = 0;
        });
    },
    livecloseFn() {
      var token = this.getCookie("token");
      axios
        .post(
          COMMOND.NEW_BASE_URL + "close_live",
          {},
          {
            headers: {
              Authorization: token,
            },
          }
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.savebtn = 0;
            this.anchorlivetwo = {
              category: "",
              league: "",
              start_time: "",
              home_team_zh: "",
              home_logo: "",
              away_team_zh: "",
              away_logo: "",
              url: "",
            };
            this.anchorlive = {
              category: "",
              league: "",
              start_time: "",
              home_team_zh: "",
              home_logo: "",
              away_team_zh: "",
              away_logo: "",
              url: "",
            };
            this.hitFn("下播成功");
          } else {
            this.hitFn(res.data.msg);
          }
        });
    },
    hitFn(msg) {
      var that = this;
      this.hit = msg;
      setTimeout(function () {
        that.hit = "";
      }, 1000);
    },
    //多页面设置cookie值
    setCookie(name, value) {
      document.cookie = name + "=" + value + ";path=/";
    }, //获取cookie值
    getCookie(name) {
      var arr = document.cookie.split("; ");
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split("=");
        if (arr2[0] == name) {
          return arr2[1];
        }
      }
      return "";
    },
    //删除图片
    closepic(div) {
      if (div == "front") {
        this.anchormsg.card_img_front = "";
      } else if (div == "obverse") {
        this.anchormsg.card_img_obverse = "";
      } else if (div == "holding") {
        this.anchormsg.card_img_holding = "";
      }
      document.getElementById(div).value = "";
    },
    //上传头像到七牛
    changepic(div) {
      var that = this;
      var f = document.getElementById(div).files[0];
      if (
        f &&
        (f.type.indexOf("png") != -1 ||
          f.type.indexOf("jpeg") != -1 ||
          f.type.indexOf("jpg") != -1 ||
          f.type.indexOf("PNG") != -1)
      ) {
        var type = f.name.split(".")[f.name.split(".").length - 1];
        var key =
          new Date().getTime() + Math.floor(Math.random() * 1000) + "." + type;
        key = "face/" + key;
        var token = this.token ? this.token : this.qiniutoken;
        var putExtra = {
          fname: f.name,
          params: {},
          mimeType: ["image/png", "image/jpeg", "image/jpg", "image/PNG"],
        };
        var config = {
          useCdnDomain: true,
        };
        if (div == "file") {
          that.loading = 1;
          key = "face/" + key;
        } else if (div == "homelogo") {
          that.homelogoloading = 1;
          key = "homelogo/" + key;
        } else if (div == "awaylogo") {
          that.awaylogoloading = 1;
          key = "awaylogo/" + key;
        } else if (div == "wx") {
          that.loading_wx = 1;
          key = "wx_code/" + key;
        } else {
          if (div == "front") {
            that.frontloading = 1;
          } else if (div == "obverse") {
            that.obverseloading = 1;
          } else if (div == "holding") {
            that.holdingloading = 1;
          }
          key = "anchor/" + key;
        }
        var observer = {
          next(res) {
            // ...
          },
          error(err) {
            if (div == "file") {
              that.loading = 0;
            } else if (div == "homelogo") {
              that.homelogoloading = 0;
            } else if (div == "awaylogo") {
              that.awaylogoloading = 0;
            } else if (div == "front") {
              that.frontloading = 0;
            } else if (div == "obverse") {
              that.obverseloading = 0;
            } else if (div == "holding") {
              that.holdingloading = 0;
            } else if (div == "wx") {
              that.loading_wx = 0;
            }

            //					    	console.log(err)
            // ...
            alert("上传图片失败");
          },
          complete(res) {
            // ...
            if (div == "file") {
              that.usermsg.face_new = "https://static.jiil1.com/" + res.key;
              that.loading = 0;
            } else if (div == "homelogo") {
              that.anchorlive.home_logo =
                "https://static.jiil1.com/" + res.key;
              that.homelogoloading = 0;
            } else if (div == "awaylogo") {
              that.anchorlive.away_logo =
                "https://static.jiil1.com/" + res.key;
              that.awaylogoloading = 0;
            } else if (div == "front") {
              that.anchormsg.card_img_front =
                "https://static.jiil1.com/" + res.key;
              that.frontloading = 0;
            } else if (div == "obverse") {
              that.anchormsg.card_img_obverse =
                "https://static.jiil1.com/" + res.key;
              that.obverseloading = 0;
            } else if (div == "holding") {
              that.anchormsg.card_img_holding =
                "https://static.jiil1.com/" + res.key;
              that.holdingloading = 0;
            } else if (div == "wx") {
              that.loading_wx = 0;
              that.usermsg.wx_code = "https://static.jiil1.com/" + res.key;
            }
            //					  		document.getElementById('img3').src = that.usermsg.face;
          },
        };
        var observable = qiniu.upload(f, key, token, putExtra, config);
        var subscription = observable.subscribe(observer); // 上传开始
      } else {
        that.hitFn("头像上传只限制png,jpg");
      }
    },
  },
};
</script>

<style>
.user {
  width: 100%;
  position: absolute;
  top: 60px;
  left: 0px;
  z-index: 100;
  background: #f9fafb;
  box-shadow: inset 0px 15px 5px -15px rgba(0, 0, 0, 0.35);
}
.user .hit {
  position: absolute;
  top: 50%;
  left: 56.7%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.5);
  padding: 10px 20px;
  color: #eee;
  z-index: 100;
}
.user_exit {
  width: 80%;
  min-width: 1000px;
  max-width: 1200px;
  margin: 30px auto 0;
  /*padding: 64px 0;*/
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
}
/*.user_exit {
		width: 1200px;
		min-height: 690px;
		overflow: hidden;
		position: relative;
		box-sizing: border-box;
	}*/
.user_face {
  width: 20%;
  min-height: 690px;
  float: left;
  margin-right: 1.7%;
  background: #fff;
  padding-top: 36px;
  box-sizing: border-box;
}
.user_face .user_name {
  height: 22px;
  line-height: 22px;
  color: #333;
  font-size: 18px;
  text-align: center;
  margin: 22px 0px 30px;
  padding: 0 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.user_face .imgPreview {
  width: 100px;
  height: 100px;
  position: relative;
  margin: auto;
}
.user_face #prompt3 {
  width: 100px;
  height: 100px;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
}
.user_face .filepath {
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.user_face #img3 {
  height: 100%;
  width: 100%;
  border-radius: 50%;
  border: 1px solid #d8d8d8;
}
.user_face .loading {
  width: 102px;
  height: 102px;
  line-height: 102px;
  text-align: center;
  background: #f9fafb;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 200;
  border-radius: 50%;
}
.user_face .anchor_tab {
  width: 125px;
  position: absolute;
  bottom: -5px;
  left: -14.5px;
  z-index: 50;
}

.user_face .anchoricon {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 50;
}
.user_face .user_tab {
  color: #333;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  border-top: 1px solid #f7f7f8;
  border-left: 2px solid #fff;
}
.user_face .user_tab:last-child {
  border-bottom: 1px solid #f7f7f8;
}
.user_face .user_tab i,
.user_face .user_tab span {
  display: inline-block;
  vertical-align: middle;
}
.user_face .user_tab i {
  font-size: 20px;
}
.user_face .user_tab.active {
  color: #e84d5b;
  background: rgba(232, 77, 91, 0.06);
  border-left: 2px solid #e84d5b;
}
.usermsgOuter {
  width: 78%;
  min-height: 739px;
  float: left;
  background: #fff;
  font-size: 16px;
  position: relative;
}
.usermsgOuter .closeExit {
  width: 40px;
  height: 24px;
  font-size: 14px;
  border: 1px solid #999;
  text-align: center;
  line-height: 22px;
  color: #999;
  border-radius: 4px;
  position: absolute;
  right: 28px;
  top: 15px;
  cursor: pointer;
  z-index: 2;
}
.usermsgOuter .tab {
  height: 52px;
  color: #999;
  border-bottom: 1px solid #bfbfbf;
  position: relative;
}
.usermsgOuter .tab span:first-child {
  margin-left: 30px;
}
.usermsgOuter .tab span {
  width: 100px;
  height: 52px;
  line-height: 52px;
  text-align: center;
  display: inline-block;
  cursor: pointer;
}
.usermsgOuter .tab span.active {
  color: #333;
}
.usermsgOuter .tab .line {
  width: 62px;
  height: 3px;
  background: #e84d5b;
  position: absolute;
  bottom: -1px;
  left: 49px;
}
.usermsgOuter .bind_alert_outer {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
}
.usermsgOuter .bind_alert {
  width: 422px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 6px;
  background: #fff;
}
.usermsgOuter .bind_alert_title {
  margin: 34px 30px 12px;
  color: #333;
  line-height: 25px;
}
.usermsgOuter .bind_alert_btn {
  overflow: hidden;
  margin-bottom: 11px;
}
.usermsgOuter .bind_alert_btn div {
  float: right;
  padding: 9px 15px;
  border-radius: 4px;
  cursor: pointer;
}
.usermsgOuter .bind_alert_btn .bind_cancel {
  color: #666;
  margin-right: 10px;
}
.usermsgOuter .bind_alert_btn .bind_cancel:hover {
  background: rgb(210, 210, 210);
}
.usermsgOuter .bind_alert_btn .bind_confirm {
  margin-right: 30px;
  color: #fff;
  background: #e84d5b;
}
.user_msg {
  width: 100%;
  height: 100%;
  padding: 39px 29px 0px;
  box-sizing: border-box;
}

.user_msg .imgPreview {
  position: absolute;
  left: 655px;
  width: 104px;
  height: 104px;
  border: 1px solid #eee;
  border-radius: 4px;
}
.user_msg .imgPreview:hover .exitface {
  display: block;
}
.user_msg #prompt3 {
  width: 104px;
  height: 104px;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
}
.user_msg .filepath {
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  padding: 0;
  display: block;
  border: none;
}
.user_msg #img3 {
  height: 100%;
  width: 100%;
  border-radius: 4px;
}
.user_msg .loading {
  width: 106px;
  height: 106px;
  line-height: 106px;
  text-align: center;
  background: #f9fafb;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 200;
  border-radius: 50%;
}
.user_msg .exitface {
  display: none;
  position: absolute;
  color: #333;
  top: 0;
  text-align: center;
  left: 0;
  width: 104px;
  height: 104px;
  line-height: 27px;
  background: rgba(30, 30, 30, 0.3);
  border-radius: 4px;
  color: #fff;
}
.user_msg .exitface div:nth-child(1) {
  margin: 20px 0 5px;
}
.user_msg .exitface i {
  font-size: 28px;
}
.promptfile {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}
.user_msg dl {
  width: 600px;
  overflow: hidden;
  margin-top: 0px;
  margin-bottom: 0px;
}
.user_msg dt {
  width: 128px;
  text-align: right;
}
.user_msg dd,
.user_msg dt {
  color: #666;
  font-size: 16px;
  line-height: 42px;
  display: inline-block;
  vertical-align: top;
  margin-bottom: 24px;
  margin-left: 0px;
}
.user_msg input {
  width: 450px;
  height: 40px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(229, 229, 229, 1);
  border-radius: 4px;
  padding-left: 10px;
  box-sizing: border-box;
}
.user_msg input[disabled="disabled"] {
  background: #e5e5e5;
}
.user_msg textarea {
  width: 450px;
  height: 184px;
  padding: 13px 10px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(229, 229, 229, 1);
  border-radius: 4px;
  box-sizing: border-box;
}
.user_msg .save {
  width: 450px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  color: #fff;
  background: #e84d5b;
  border-radius: 4px;
  margin-left: 133px;
  cursor: pointer;
}
.user_msg .imgPreview_wx:hover .exitface {
  display: block;
}
.user_msg .imgPreview_wx {
  left: 400px;
  width: 104px;
  height: 104px;
  border: 1px solid #eee;
  border-radius: 4px;
  position: relative;
  left: 0;
  overflow: hidden;
}
.user_msg .prompt_wx {
  width: 104px;
  height: 104px;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
}
.user_msg .img_wx {
  height: 104px;
  width: 104px;
  border-radius: 4px;
}
.user_msg .save.save_wx {
  width: 74px;
}
.user_msg .loading.loading_wx {
  border-radius: 4px;
}
.user_msg .card_title {
  font-size: 20px;
  line-height: 28px;
}
.user_msg .card_img {
  /*overflow: hidden;*/
  /*height: 155px;*/
  margin-top: 22px;
  margin-left: 74px;
}
.user_msg .card_img .close {
  width: 22px;
  height: 22px;
  position: absolute;
  top: -12px;
  right: -1px;
  color: #e84d5b;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
  z-index: 200;
}
.user_msg .card_img .close i {
  font-size: 26px;
  position: absolute;
  bottom: -4px;
  right: -3px;
}
.user_msg .card_img > div {
  float: left;
  width: 29.5%;
}
.user_msg .card_img > div:not(:last-child) {
  margin-right: 3.2%;
}
.user_msg .card_img .title {
  text-align: center;
  color: #999;
  font-size: 16px;
  line-height: 20px;
  margin-top: 10px;
}
.user_msg .card_img .img_front {
  width: 100%;
  height: 52.8%;
  position: relative;
}
.user_msg .card_img .img_front .loading {
  width: 100%;
  height: 100%;
  line-height: 130px;
  text-align: center;
  background: #f9fafb;
  border-radius: 6px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 200;
}
.user_msg .card_img .img_front .loading span {
  display: inline-block;
  vertical-align: middle;
}
.user_msg .card_img .prompt {
  width: 100%;
  height: 100%;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
}
.user_msg .card_img .filepath {
  width: 100%;
  height: 100%;
  opacity: 0;
}
.user_msg .card_img img {
  height: 100%;
  width: 100%;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  display: block;
}
.user_msg .user_tip {
  color: #999;
  padding: 29px 0 42px;
}
.user_msg .protocol {
  height: 24px;
  padding-bottom: 40px;
  color: #999;
}
.user_msg .protocol > i,
.user_msg .protocol > i,
.user_msg .protocol > a,
.user_msg .protocol > span {
  display: inline-block;
  vertical-align: middle;
}
.user_msg .protocol i,
.user_msg .protocol a {
  color: #e84d5b;
  text-decoration: none;
}
.user_msg .protocol i {
  font-size: 20px;
  cursor: pointer;
}
.user_msg .protocol .xieyi_cicle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1px solid #999;
  margin: 0 1.5px;
}
.user_msg .verify {
  text-align: center;
  margin-top: 90px;
}
.user_msg .verify div:nth-child(2) {
  color: #434343;
  font-size: 24px;
  margin-top: 41px;
}
.user_msg .verify div:nth-child(3) {
  color: #999;
  line-height: 22px;
  margin-top: 17px;
}
.user_msg .verify div.liveBtn {
  width: 122px;
  padding: 7px 0;
  color: #e84d5b;
  border: 1px solid #e84d5b;
  border-radius: 20px;
  line-height: 20px;
  margin: 46px auto 0;
  cursor: pointer;
}
.user_msg .verify div.liveBtn i {
  font-size: 22px;
}
.user_msg .verify div.liveBtn i,
.user_msg .verify div.liveBtn span {
  display: inline-block;
  vertical-align: middle;
}
.user_msg .verify div.reloadBtn {
  width: 130px;
  height: 38px;
  color: #fff;
  line-height: 38px;
  background: linear-gradient(
    0deg,
    rgba(251, 231, 79, 1) 1%,
    rgba(251, 231, 79, 1) 100%
  );
  border-radius: 19px;
  margin: 60px auto 0px;
  cursor: pointer;
}
.user_msg.anchor {
  height: 738px;
}
.user_msg.anchor dd,
.user_msg.anchor dt {
  font-size: 14px;
  margin-bottom: 20px;
}
.user_msg.anchor dd {
  position: relative;
  min-width: 450px;
}
.user_msg.anchor dt span {
  color: #ff3332;
}
.user_msg.anchor dt {
  width: 102px;
}
.user_msg.anchor input {
  height: 38px;
}
.user_msg.anchor dl {
  margin-bottom: 20px;
}
.user_msg.anchor select {
  width: 450px;
  height: 38px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(229, 229, 229, 1);
  border-radius: 4px;
  padding-left: 10px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.user_msg.anchor select:focus {
  border-width: 1px;
}
.user_msg.anchor .logoprompt {
  width: 80px;
  height: 80px;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
}
.user_msg.anchor .logoprompt .filepath {
  width: 80px;
  height: 80px;
  opacity: 0;
  cursor: pointer;
  padding: 0;
  display: block;
}
.user_msg.anchor img {
  height: 80px;
  width: 80px;
  display: block;
}
.user_msg.anchor dd .loading {
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  background: #f9fafb;
  border-radius: 6px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 200;
}
.user_msg .anchorsave {
  width: 90px;
  color: #fff;
  padding: 10px 0;
  background: #e84d5b;
  border-radius: 4px;
  text-align: center;
  margin-left: 107px;
  cursor: pointer;
  float: left;
}
.user_msg .liveclose {
  width: 90px;
  color: #fff;
  padding: 10px 0;
  background: #e84d5b;
  border-radius: 4px;
  text-align: center;
  margin-left: 269px;
  cursor: pointer;
  float: left;
}
.user .web_copyright {
  width: 1000px;
  color: #999;
  margin: 62px auto;
  font-size: 14px;
}
.user_msg.course {
  color: #434343;
  font-size: 14px;
  line-height: 22px;
}
.user_msg.course a {
  color: -webkit-link;
  text-decoration: underline;
}
.user_msg.course h3 {
  font-size: 20px;
  text-align: center;
  padding: 39px 0;
  letter-spacing: 6px;
}
.user_msg.course img {
  box-shadow: 0px 0px 6px 0px rgba(43, 43, 43, 0.32);
}
.user_msg.course .OBSimg {
  margin-bottom: 20px;
}
.user_msg.course .OBSimg img {
  width: 100%;
  margin-top: 18px;
}
.user_msg.course .OBSimg img:nth-child(2n) {
  margin-right: 15px;
}
.user_msg.course .img {
  text-align: center;
  padding: 18px 0 30px;
}
.user_msg.course .end1 {
  margin-bottom: 30px;
}
.user_msg.course .end2 {
  margin-bottom: 134px;
}
.user_msg .follow_alert {
  width: 200px;
  height: 50px;
  font-size: 18px;
  background: rgba(18, 18, 18, 0.4);
  text-align: center;
  line-height: 50px;
  color: #fff;
  border-radius: 25px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, 0);
}

.user_msg .nofollow {
  text-align: center;
  margin-top: 59px;
}

.user_msg .follow {
  overflow: hidden;
  margin-bottom: 20px;
}

.user_msg .follow .anchor {
  float: left;
  width: 367px;
}

.user_msg .follow .anchor img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 14px;
}

.user_msg .follow .anchor span {
  display: inline-block;
  vertical-align: middle;
  width: 270px;
  font-size: 15px;
  line-height: 17px;
}

.user_msg .follow .follow_btn {
  width: 76px;
  height: 32px;
  float: left;
  border: 1px solid #e84d5b;
  color: #e84d5b;
  border-radius: 16px;
  text-align: center;
  line-height: 28px;
  margin-top: 6px;
  cursor: pointer;
  font-size: 12px;
}

.user_msg .follow .follow_btn.active {
  border: 1px solid #999;
  color: #999;
  line-height: 30px;
}

.user_msg .follow .follow_btn .follow_add {
  font-size: 16px;
  font-weight: bold;
  padding-right: 4px;
}

.user_msg .follow_outer {
  height: 580px;
}

.user_msg .follow_outer,
.user_msg .pagination {
  margin-bottom: 40px;
  padding-left: 18px;
}

.user_msg .pagination input {
  width: 100%;
}
.user_msg .pagination .el-pagination {
  color: #312d2c;
  font-weight: 100;
}
.user_msg .pagination .el-pagination .el-pagination__confirm {
  display: inline-block;
  border: 1px solid #eee;
  width: 46px;
  text-align: center;
  font-size: 12px;
  margin-left: 12px;
  cursor: pointer;
}
.el-pagination button,
.el-pagination span:not([class*="suffix"]) {
  font-size: 12px;
}
.user_msg .pagination .el-pagination__total,
.user_msg .pagination input {
  color: #312d2c;
}
.user_msg .pagination .el-pager li.active {
  color: #fff;
  background: #e84d5b;
  height: 22px;
  line-height: 22px;
  margin-top: 3px;
}

.user_msg .pagination .el-pager li:hover {
  color: #e84d5b;
}

.user_msg .pagination .el-pager li.active:hover {
  color: #fff;
}

.user_msg .pagination .el-pagination__jump {
  margin-left: 12px;
  color: #999;
}

.user_msg .pagination .el-pagination__total {
  margin-left: 12px;
}
</style>